@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(1_368_465_124)
public val Res.string.UPDATE_AGE_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_AGE_SCREEN_TITLE", "UPDATE_AGE_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11329, 43),
      ))
    }

@delegate:ResourceContentHash(943_443_821)
public val Res.string.UPDATE_FOOD_PREFERENCES_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", "UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11373, 68),
      ))
    }

@delegate:ResourceContentHash(258_132_152)
public val Res.string.UPDATE_FOOD_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_FOOD_SCREEN_TITLE", "UPDATE_FOOD_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11442, 44),
      ))
    }

@delegate:ResourceContentHash(-251_898_997)
public val Res.string.UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", "UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11487, 85),
      ))
    }

@delegate:ResourceContentHash(-36_853_586)
public val Res.string.UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", "UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11573, 84),
      ))
    }

@delegate:ResourceContentHash(-1_314_665_315)
public val Res.string.UPDATE_HEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_HEIGHT_SCREEN_TITLE", "UPDATE_HEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11658, 50),
      ))
    }

@delegate:ResourceContentHash(1_674_893_667)
public val Res.string.UPDATE_INITIAL_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", "UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11709, 70),
      ))
    }

@delegate:ResourceContentHash(528_869_666)
public val Res.string.UPDATE_NAME_INFO: StringResource by lazy {
      StringResource("string:UPDATE_NAME_INFO", "UPDATE_NAME_INFO", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11780, 76),
      ))
    }

@delegate:ResourceContentHash(1_380_475_594)
public val Res.string.UPDATE_NAME_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_NAME_SCREEN_TITLE", "UPDATE_NAME_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11857, 44),
      ))
    }

@delegate:ResourceContentHash(1_640_151_243)
public val Res.string.UPDATE_TARGET_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_TARGET_WEIGHT_SCREEN_TITLE", "UPDATE_TARGET_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11902, 65),
      ))
    }

@delegate:ResourceContentHash(1_280_443_786)
public val Res.string.UPDATE_WEIGHT_INFO_LABEL: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_INFO_LABEL", "UPDATE_WEIGHT_INFO_LABEL", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11968, 120),
      ))
    }

@delegate:ResourceContentHash(687_252_615)
public val Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_LOG_SCREEN_TITLE", "UPDATE_WEIGHT_LOG_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12089, 62),
      ))
    }

@delegate:ResourceContentHash(687_252_615)
public val Res.string.UPDATE_WEIGHT_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:UPDATE_WEIGHT_SCREEN_TITLE", "UPDATE_WEIGHT_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12152, 58),
      ))
    }

@delegate:ResourceContentHash(-411_708_722)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_MESSAGE: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", "USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12211, 87),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", "USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12299, 63),
      ))
    }

@delegate:ResourceContentHash(-952_558_483)
public val Res.string.USER_AVATAR_DELETE_CONFIRMATION_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_DELETE_CONFIRMATION_TITLE", "USER_AVATAR_DELETE_CONFIRMATION_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12363, 65),
      ))
    }

@delegate:ResourceContentHash(-737_200_067)
public val Res.string.USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", "USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12429, 62),
      ))
    }

@delegate:ResourceContentHash(-817_283_504)
public val Res.string.USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", "USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12492, 66),
      ))
    }

@delegate:ResourceContentHash(642_488_771)
public val Res.string.USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", "USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12559, 75),
      ))
    }

@delegate:ResourceContentHash(-1_830_944_830)
public val Res.string.USER_AVATAR_IMAGE_PICKER_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_IMAGE_PICKER_TITLE", "USER_AVATAR_IMAGE_PICKER_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12635, 62),
      ))
    }

@delegate:ResourceContentHash(1_985_170_477)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_MESSAGE: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", "USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12698, 195),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", "USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12894, 67),
      ))
    }

@delegate:ResourceContentHash(617_139_570)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_TITLE", "USER_AVATAR_PERMISSION_REQUIRED_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12962, 73),
      ))
    }

@delegate:ResourceContentHash(-784_638_389)
public val Res.string.WEIGHT_HISTORY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:WEIGHT_HISTORY_SCREEN_TITLE", "WEIGHT_HISTORY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13036, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("UPDATE_AGE_SCREEN_TITLE", Res.string.UPDATE_AGE_SCREEN_TITLE)
  map.put("UPDATE_FOOD_PREFERENCES_SCREEN_TITLE", Res.string.UPDATE_FOOD_PREFERENCES_SCREEN_TITLE)
  map.put("UPDATE_FOOD_SCREEN_TITLE", Res.string.UPDATE_FOOD_SCREEN_TITLE)
  map.put("UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT", Res.string.UPDATE_HEIGHT_HIGH_VALUE_ERROR_FORMAT)
  map.put("UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT", Res.string.UPDATE_HEIGHT_LOW_VALUE_ERROR_FORMAT)
  map.put("UPDATE_HEIGHT_SCREEN_TITLE", Res.string.UPDATE_HEIGHT_SCREEN_TITLE)
  map.put("UPDATE_INITIAL_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_INITIAL_WEIGHT_SCREEN_TITLE)
  map.put("UPDATE_NAME_INFO", Res.string.UPDATE_NAME_INFO)
  map.put("UPDATE_NAME_SCREEN_TITLE", Res.string.UPDATE_NAME_SCREEN_TITLE)
  map.put("UPDATE_TARGET_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_TARGET_WEIGHT_SCREEN_TITLE)
  map.put("UPDATE_WEIGHT_INFO_LABEL", Res.string.UPDATE_WEIGHT_INFO_LABEL)
  map.put("UPDATE_WEIGHT_LOG_SCREEN_TITLE", Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE)
  map.put("UPDATE_WEIGHT_SCREEN_TITLE", Res.string.UPDATE_WEIGHT_SCREEN_TITLE)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_MESSAGE", Res.string.USER_AVATAR_DELETE_CONFIRMATION_MESSAGE)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON", Res.string.USER_AVATAR_DELETE_CONFIRMATION_POSITIVE_BUTTON)
  map.put("USER_AVATAR_DELETE_CONFIRMATION_TITLE", Res.string.USER_AVATAR_DELETE_CONFIRMATION_TITLE)
  map.put("USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_CAMERA_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_DELETE_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON", Res.string.USER_AVATAR_IMAGE_PICKER_GALLERY_BUTTON)
  map.put("USER_AVATAR_IMAGE_PICKER_TITLE", Res.string.USER_AVATAR_IMAGE_PICKER_TITLE)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_MESSAGE", Res.string.USER_AVATAR_PERMISSION_REQUIRED_MESSAGE)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", Res.string.USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_TITLE", Res.string.USER_AVATAR_PERMISSION_REQUIRED_TITLE)
  map.put("WEIGHT_HISTORY_SCREEN_TITLE", Res.string.WEIGHT_HISTORY_SCREEN_TITLE)
}
